<template>
  <div v-if="!isEmpty" class="chart-wrap" ref="chartWrap" />
  <div v-else class="empty-box">暂无数据</div>
</template>
<script>

import { Chart } from '@/utils/g2'
import { formatPercent } from '@/utils/strUtil'
export default {
  name: 'FrontPieChart',
  props: {
    chartHeight: {
      type: Number,
      default: 400
    },
    chartData: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      isEmpty: false
    }
  },
  watch: {
    chartData(newVal) {
      this.initChart(newVal)
    }
  },
  created() {
    this.chart = null
    this.initChart(this.chartData)
  },
  beforeDestroy() {
    this.destroyChart()
  },
  methods: {
    initChart(data = []) {
      const { chartWrap } = this.$refs
      if (chartWrap) {
        if (this.chart) {
          this.updateChart(data)
        } else {
          this.renderChart(chartWrap, data)
        }
      } else {
        this.$nextTick(() => {
          this.initChart(data)
        })
      }
    },
    renderChart(container, data) {
      this.chart = new Chart({
        container,
        autoFit: true,
        width: 500,
        height: this.chartHeight,
        padding: [20, 40, 30, 60]
      })
      this.chart.data(data)
      this.chart.scale('value', {
        formatter(val) {
          return formatPercent(val)
        }
      })
      this.chart.tooltip({
        showTitle: false,
        domStyles: {
          'g2-tooltip': {
            width: '220px',
            padding: '8px 12px'
          },
          'g2-tooltip-title': {
            display: 'none'
          },
        },
        itemTpl: '<li><span style="background-color:{color};" class="g2-tooltip-marker"></span>{name}: {value}</li>'
      })
      this.chart.legend(false)
      this.chart.coordinate('theta', {
        radius: 0.75,
        innerRadius: 0.6
      })
      this.chart.interval().adjust('stack').position('value').color('name', ['#6AC8FF', '#4A73FB', '#D6D8FB', '#8ed1ff']).label('value', {
        style: {
          fontSize: 16
        },
        content: (originData) => {
          return `${originData.name} ${formatPercent(originData.value)}`
        }
      }).tooltip('name*value', function(name, value) {
        return {
          name,
          value: formatPercent(value)
        }
      })
      this.chart.render()
    },
    updateChart(data) {
      this.isEmpty = this.checkEmpty(data)
      if (!this.isEmpty) {
        this.chart.changeData(data)
      } else {
        this.destroyChart()
      }
    },
    checkEmpty(data) {
      return !data.find(({ value }) => value !== 0)
    },
    destroyChart() {
      if (this.chart) {
        this.chart.destroy()
        this.chart = null
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.chart-wrap {
  height: 400px;
}

.empty-box {
  text-align: center;
  line-height: 440px;
}
</style>
